import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'

export const StyledButton = styled(Button)(({ theme, color = 'primary' }) => ({
  fontSize: '.75rem',
  fontWeight: '500',
  padding: '.3rem .5rem',
  backgroundColor: theme.palette[color].main,
  '&:hover': {
    backgroundColor: theme.typography.button.hover,
    backgroundImage: `linear-gradient(rgb(0 0 0/10%) 0 0)`,
  },
}))
